import { FC, memo } from 'react'
import Page from 'components/Page'
import { StickyPanelFrame } from 'components/Page/StickyPanelFrame'
import { SeatTypesMagicTable } from 'modules/Seats/SeatMetrics/SeatTypesMagicTable'
import { IconPlus, Button } from '@sequencehq/core-components'
import { CreateSeatTypeDrawer } from 'Seats/SeatMetric/CreateSeatTypeDrawer'
import { ProtectedButton, usePermissions } from 'lib/rbac'
import { Outlet } from 'react-router-dom'

const SeatTypes: FC = memo(() => {
  const { can } = usePermissions()

  return (
    <>
      <StickyPanelFrame>
        <Page
          title="Metrics"
          actionElement={
            can('org.usage:create') ? (
              <CreateSeatTypeDrawer
                trigger={
                  <Button
                    variant="primary"
                    leadingIcon={<IconPlus color="inherit" />}
                    data-testid="seatMetrics.add"
                  >
                    New seat metric
                  </Button>
                }
              />
            ) : (
              <ProtectedButton permission="org.usage:create">
                <Button
                  variant="primary"
                  leadingIcon={<IconPlus color="inherit" />}
                  data-testid="seatMetrics.add"
                >
                  New seat metric
                </Button>
              </ProtectedButton>
            )
          }
        >
          <SeatTypesMagicTable />
        </Page>
      </StickyPanelFrame>
      <Outlet />
    </>
  )
})

export default SeatTypes
